import { Header } from './Header';
import { Remove } from './Remove';
import { RemoveAll } from './RemoveAll';

export const ActionCell = { Remove, RemoveAll, Header };
